import { useAtom } from "@reatom/npm-react";
import { useCallback, useEffect, useState } from "react";
import { useGravityDevice } from "src/hooks/useGravityDevice";
import { changeUserDataModalAtom } from "src/store/atoms";
import { getMeRequest } from "src/store/fetchers";

import { ChangeUserDataModal, ChangeUserDataSheet } from "./components";

export const ResponsiveChangeUserDataWidget = () => {
  const { isMobile } = useGravityDevice();

  const [changeUserDataModalIsOpen, setChangeUserDataModalIsOpen] = useAtom(
    changeUserDataModalAtom,
  );
  const [wasClosed, setWasClosed] = useState(false);

  const [userData] = useAtom(getMeRequest.dataAtom);
  const [isLoading] = useAtom(getMeRequest.isLoadingAtom);

  const hasPhone = !!userData?.phone;

  useEffect(() => {
    // eslint-disable-next-line react-you-might-not-need-an-effect/no-event-handler -- открываем модалку один раз при загрузке неполных userData (пока юзер её не закрыл)
    if (!userData || wasClosed || isLoading) return;

    const hasAnyName = userData.firstName || userData.lastName;

    if (!hasAnyName || !userData.phone) {
      setChangeUserDataModalIsOpen(true);
    }
  }, [isLoading, setChangeUserDataModalIsOpen, userData, wasClosed]);

  const handleClose = useCallback(() => {
    setChangeUserDataModalIsOpen(false);
    setWasClosed(true);
  }, [setChangeUserDataModalIsOpen]);

  if (isMobile) {
    return (
      <ChangeUserDataSheet
        open={changeUserDataModalIsOpen}
        onClose={handleClose}
        isLoading={isLoading}
        hasPhone={hasPhone}
      />
    );
  }
  return (
    <ChangeUserDataModal
      open={changeUserDataModalIsOpen}
      onClose={handleClose}
      isLoading={isLoading}
      hasPhone={hasPhone}
    />
  );
};
